// Only resume local app routes; never accept an external or another login URL.
export function safeAuthReturnTo(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || /[\\\s]/.test(value)
    || Array.from(value).some((character) => character.charCodeAt(0) < 32)) return null;
  try {
    const url = new URL(value, 'https://promptcrew.invalid');
    if (url.origin !== 'https://promptcrew.invalid') return null;
    if (url.pathname.startsWith('/auth/') && url.pathname !== '/auth/mcp/authorize') return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function getAuthReturnTo(location) {
  const from = location.state?.from;
  const statePath = typeof from === 'string' ? from : from?.pathname
    ? `${from.pathname}${from.search || ''}${from.hash || ''}` : null;
  return safeAuthReturnTo(statePath)
    || safeAuthReturnTo(new URLSearchParams(location.search || '').get('returnTo'));
}

export function authLoginUrl(location, sessionExpired = false) {
  const params = new URLSearchParams();
  if (sessionExpired) params.set('sessionExpired', '1');
  const returnTo = safeAuthReturnTo(`${location.pathname}${location.search || ''}${location.hash || ''}`)
    || getAuthReturnTo(location);
  if (returnTo) params.set('returnTo', returnTo);
  const query = params.toString();
  return `/auth/login${query ? `?${query}` : ''}`;
}
